import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionsHubPage } from '#/modules/subscriptions/hub/hub-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/subscriptions')({
  component: SubscriptionsHubPage,
  validateSearch: validateListSearch,
})
